"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Leech_OnDamageDealtEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Effect_Leech_OnDamageDealtEventHandlerScript = class Effect_Leech_OnDamageDealtEventHandlerScript {
    run(sequence, container, handler, event) {
        const { damage } = event.args;
        const { percent, target = Target_1.Target.Self } = handler.args.scriptArgs;
        const amount = Math.round(damage.amount * percent / 100);
        if (amount <= 0) {
            return;
        }
        const toHeal = container.selectLivingTargets(event.subject, target)
            .filter(targetId => !container.isFullHealth(targetId));
        for (const targetId of toHeal) {
            container.applyHealing({
                sequence,
                healerId: event.subject,
                targetId,
                amount
            });
        }
    }
};
Effect_Leech_OnDamageDealtEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Leech_OnDamageDealt")
], Effect_Leech_OnDamageDealtEventHandlerScript);
exports.Effect_Leech_OnDamageDealtEventHandlerScript = Effect_Leech_OnDamageDealtEventHandlerScript;
